import React from 'react';

// 🎨 채팅 카테고리 전용 SVG 아이콘 시스템
// 토스 디자인 철학: Simple is the Best - 깔끔하고 직관적인 아이콘

const IconBase = ({ children, className = "", size = 24, color = "currentColor", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`chat-category-icon ${className}`}
    {...props}
  >
    {children}
  </svg>
);

// 📋 생기부 & 학생기록 전문가
export const DocumentIcon = (props) => (
  <IconBase {...props}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14,2 14,8 20,8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10,9 9,9 8,9" />
  </IconBase>
);

// 📄 공문서 & 가정통신문 전문가  
export const FileIcon = (props) => (
  <IconBase {...props}>
    <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
    <polyline points="13,2 13,9 20,9" />
    <line x1="8" y1="13" x2="16" y2="13" />
    <line x1="8" y1="17" x2="16" y2="17" />
  </IconBase>
);

// 🤝 종합 상담 & 지도 전문가
export const HandshakeIcon = (props) => (
  <IconBase {...props}>
    <path d="M11 12h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 14" />
    <path d="m7 18 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9" />
    <path d="m2 13 6 6 3-3" />
    <path d="m8 21 2-2" />
  </IconBase>
);

// 🧠 교사 멘탈 케어 전문가
export const BrainIcon = (props) => (
  <IconBase {...props}>
    <path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z" />
    <path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z" />
    <path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4" />
    <path d="M17.599 6.5a3 3 0 0 0 .399-1.375" />
    <path d="M6.003 5.125A3 3 0 0 0 6.401 6.5" />
    <path d="M3.477 10.896a4 4 0 0 1 .585-.396" />
    <path d="M19.938 10.5a4 4 0 0 1 .585.396" />
    <path d="M6 18a4 4 0 0 1-1.967-.516" />
    <path d="M19.967 17.484A4 4 0 0 1 18 18" />
  </IconBase>
);

// 🏫 학급 운영 & 세팅 전문가
export const SchoolIcon = (props) => (
  <IconBase {...props}>
    <path d="M12 3L2 7l10 4 10-4-10-4z" />
    <path d="M2 17l10 4 10-4" />
    <path d="M2 12l10 4 10-4" />
  </IconBase>
);

// 📊 평가 & 성적 관리 전문가
export const ChartIcon = (props) => (
  <IconBase {...props}>
    <line x1="18" y1="20" x2="18" y2="10" />
    <line x1="12" y1="20" x2="12" y2="4" />
    <line x1="6" y1="20" x2="6" y2="14" />
  </IconBase>
);

// 📊 PPT 만들기 전문가 (프레젠테이션 화면)
export const PresentationIcon = (props) => (
  <IconBase {...props}>
    <rect x="2" y="3" width="20" height="14" rx="2" />
    <path d="M8 21h8" />
    <path d="M12 17v4" />
    <path d="M7 8h4" />
    <path d="M7 11h8" />
  </IconBase>
);

// 🎪 행사 기획 & 운영 전문가
export const EventIcon = (props) => (
  <IconBase {...props}>
    <path d="M8 2v4" />
    <path d="M16 2v4" />
    <rect width="18" height="18" x="3" y="4" rx="2" />
    <path d="M3 10h18" />
    <path d="M8 14h.01" />
    <path d="M12 14h.01" />
    <path d="M16 14h.01" />
    <path d="M8 18h.01" />
    <path d="M12 18h.01" />
    <path d="M16 18h.01" />
  </IconBase>
);

// 🌟 자유로운 상담
export const StarIcon = (props) => (
  <IconBase {...props}>
    <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
  </IconBase>
);

// 🖼️ 이미지 생성
export const ImageIcon = (props) => (
  <IconBase {...props}>
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
    <circle cx="8.5" cy="8.5" r="1.5" />
    <polyline points="21 15 16 10 5 21" />
  </IconBase>
);

// 💎 PRO AI 모델 (특별 스타일링)
export const DiamondIcon = (props) => (
  <IconBase {...props}>
    <path d="M6 3h12l4 6-10 13L2 9l4-6z" />
    <path d="M11 3L8 9l4 13 4-13-3-6" />
    <path d="M2 9h20" />
  </IconBase>
);

// 📝 학습지 생성 전문가 (문서+체크마크)
export const WorksheetIcon = (props) => (
  <IconBase {...props}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14,2 14,8 20,8" />
    <path d="M9 15l2 2 4-4" />
  </IconBase>
);

// 💬 학부모 소통 전문가 (말풍선)
export const ParentChatIcon = (props) => (
  <IconBase {...props}>
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </IconBase>
);

// 🎯 학생 상담 전문가 (타겟/목표) — 레거시 호환용 유지
export const StudentCounselingIcon = (props) => (
  <IconBase {...props}>
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="6" />
    <circle cx="12" cy="12" r="2" />
  </IconBase>
);

// 💚 상담·마음 통합 (counseling_care) — 하트 + 사람 모티프로 학생 상담 + 교사 마음 케어를 함께 표현
export const CounselingCareIcon = (props) => (
  <IconBase {...props}>
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
    <circle cx="12" cy="11" r="1.4" fill="currentColor" />
  </IconBase>
);

// 🗂️ 행정 업무 (admin_docs) — 서류가방/폴더 + 체크 모티프
export const AdminDocsIcon = (props) => (
  <IconBase {...props}>
    <rect x="3" y="6" width="18" height="14" rx="2" />
    <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <path d="M9 14l2 2 4-4" />
  </IconBase>
);

// ===== 카테고리 런처 전용 실루엣 =====
// 기존 record/document/worksheet_gen 아이콘은 셋 다 "모서리 접힌 종이" 모양이라 첫 화면에서 구별되지 않았다.
// 각 할 일의 동작(쓰기 / 학생 기록 / 양식 올리기 / 결재)이 드러나는 실루엣으로 바꾼다.
// 기존 아이콘 컴포넌트(DocumentIcon 등)는 다른 화면에서 쓰이므로 그대로 두고 매핑만 교체한다.

// ✏️ 학습지 — 연필 + 밑줄 (문항을 쓴다)
export const WorksheetPencilIcon = (props) => (
  <IconBase {...props}>
    <path d="M4 20l4-1L19 8l-3-3L5 16z" />
    <path d="M13 7l3 3" />
    <path d="M4 21h16" />
  </IconBase>
);

// 🪪 생기부 — 학생 기록 카드 (사람 + 기록 줄)
export const StudentRecordIcon = (props) => (
  <IconBase {...props}>
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <circle cx="9" cy="11" r="2.2" />
    <path d="M5.5 17c.6-1.8 2-2.6 3.5-2.6s2.9.8 3.5 2.6" />
    <path d="M14 9h5" />
    <path d="M14 13h5" />
  </IconBase>
);

// ⬆️ 한글 문서 — 종이 + 위 화살표 (양식을 올린다)
export const HwpUploadIcon = (props) => (
  <IconBase {...props}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14,2 14,8 20,8" />
    <path d="M12 18v-6" />
    <path d="m9 15 3-3 3 3" />
  </IconBase>
);

// 🔏 행정 문서 — 도장 (결재·공문)
export const StampIcon = (props) => (
  <IconBase {...props}>
    <path d="M9 11V7a3 3 0 0 1 6 0v4" />
    <rect x="4" y="11" width="16" height="5" rx="1.5" />
    <path d="M6 16v4h12v-4" />
  </IconBase>
);

// 🎯 카테고리 아이콘 매핑
export const getCategoryIcon = (categoryId, props = {}) => {
  const IconMap = {
    record: StudentRecordIcon,
    document: HwpUploadIcon,
    worksheet_gen: WorksheetPencilIcon,
    parent_communication: ParentChatIcon,
    counseling_care: CounselingCareIcon,  // 🆕 통합 상담·마음
    admin_docs: StampIcon,                 // 행정 업무 — 도장(결재) 실루엣
    student_counseling: CounselingCareIcon, // 레거시 → 통합 아이콘 (URL/구대화 호환)
    teacher_care: CounselingCareIcon,       // 레거시 → 통합 아이콘
    evaluation: ChartIcon,
    ppt_maker: PresentationIcon,
    general: StarIcon,
    image_generation: ImageIcon,
    pro_ai: DiamondIcon
  };

  const IconComponent = IconMap[categoryId] || StarIcon;
  return <IconComponent {...props} />;
};

// 🚀 PRO 모달 전용 아이콘들
export const FileUploadIcon = (props) => (
  <IconBase {...props}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14,2 14,8 20,8" />
    <path d="M12 18v-6" />
    <path d="m9 15 3-3 3 3" />
  </IconBase>
);

export const UpgradeIcon = (props) => (
  <IconBase {...props}>
    <path d="M8 3l4-4 4 4" />
    <path d="M12 3v14" />
    <path d="M4 17a6 6 0 0 1 .31-2H6l2 2 2-2 2 2 2-2 2 2h1.69A6 6 0 0 1 20 17v2a6 6 0 0 1-6 6H10a6 6 0 0 1-6-6v-2z" />
  </IconBase>
);

export const CloseIcon = (props) => (
  <IconBase {...props}>
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </IconBase>
);

export const ModelIcon = (props) => (
  <IconBase {...props}>
    <circle cx="12" cy="12" r="3" />
    <circle cx="12" cy="1" r="1" />
    <circle cx="12" cy="23" r="1" />
    <circle cx="20.49" cy="8.51" r="1" />
    <circle cx="3.51" cy="15.49" r="1" />
    <circle cx="20.49" cy="15.49" r="1" />
    <circle cx="3.51" cy="8.51" r="1" />
    <line x1="12" y1="8" x2="12" y2="16" />
    <line x1="16" y1="12" x2="8" y2="12" />
  </IconBase>
);

// 🎯 생기부 페이지 전용 아이콘들
export const TargetIcon = (props) => (
  <IconBase {...props}>
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="6" />
    <circle cx="12" cy="12" r="2" />
  </IconBase>
);

export const ClipboardIcon = (props) => (
  <IconBase {...props}>
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
    <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
  </IconBase>
);

export const SettingsIcon = (props) => (
  <IconBase {...props}>
    <circle cx="12" cy="12" r="3" />
    <path d="M12 1v6m0 6v6m11-7h-6m-6 0H1m21-7h-6m-6 0H1m21 7h-6m-6 0H1" />
  </IconBase>
);

export const RulerIcon = (props) => (
  <IconBase {...props}>
    <path d="M21.3 8.7l-9.6-9.6c-.4-.4-1-.4-1.4 0l-9.6 9.6c-.4.4-.4 1 0 1.4l9.6 9.6c.4.4 1 .4 1.4 0l9.6-9.6c.4-.4.4-1 0-1.4z" />
    <line x1="7" y1="17" x2="17" y2="7" />
    <line x1="7" y1="12" x2="12" y2="7" />
    <line x1="12" y1="17" x2="17" y2="12" />
  </IconBase>
);

export const PaletteIcon = (props) => (
  <IconBase {...props}>
    <circle cx="13.5" cy="6.5" r=".5" />
    <circle cx="17.5" cy="10.5" r=".5" />
    <circle cx="8.5" cy="7.5" r=".5" />
    <circle cx="6.5" cy="12.5" r=".5" />
    <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z" />
  </IconBase>
);

export const LightbulbIcon = (props) => (
  <IconBase {...props}>
    <path d="M9 21h6" />
    <path d="M12 17h.01" />
    <path d="M12 3a4 4 0 0 1 4 4c0 1.5-.5 2-1 3h-6c-.5-1-.5-1.5-1-3a4 4 0 0 1 4-4z" />
    <path d="M8 17a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1" />
  </IconBase>
);

export const CheckCircleIcon = (props) => (
  <IconBase {...props}>
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22,4 12,14.01 9,11.01" />
  </IconBase>
);

export const WordCountIcon = (props) => (
  <IconBase {...props}>
    <path d="M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2z" />
    <path d="M8 21v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4" />
    <line x1="7" y1="10" x2="17" y2="10" />
    <line x1="7" y1="13" x2="13" y2="13" />
  </IconBase>
);

// 🎯 Pricing 페이지 전용 아이콘들
export const RobotIcon = (props) => (
  <IconBase {...props}>
    <rect x="6" y="4" width="12" height="16" rx="2" />
    <circle cx="9" cy="9" r="1" fill="currentColor"/>
    <circle cx="15" cy="9" r="1" fill="currentColor"/>
    <path d="M9 13h6" strokeLinecap="round"/>
    <path d="M12 2v2M6 11h-2M20 11h-2M4 20l2-2M20 20l-2-2"/>
  </IconBase>
);

export const BrainMemoryIcon = (props) => (
  <IconBase {...props}>
    <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c5.5 0 10-4.5 10-10S17.5 2 12 2z"/>
    <path d="M8 12c0-1.5.5-3 2-4s3.5-1 5-1M16 12c0 1.5-.5 3-2 4s-3.5 1-5 1"/>
    <circle cx="9" cy="9" r="1" fill="currentColor"/>
    <circle cx="15" cy="15" r="1" fill="currentColor"/>
  </IconBase>
);

export const SearchIcon = (props) => (
  <IconBase {...props}>
    <circle cx="11" cy="11" r="8" />
    <path d="M21 21L16.5 16.5" strokeLinecap="round"/>
  </IconBase>
);

export const BookIcon = (props) => (
  <IconBase {...props}>
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    <line x1="8" y1="7" x2="16" y2="7" />
    <line x1="8" y1="11" x2="14" y2="11" />
  </IconBase>
);

export const SparkleIcon = (props) => (
  <IconBase {...props}>
    <path d="M12 3l2.5 7.5L22 13l-7.5 2.5L12 23l-2.5-7.5L2 13l7.5-2.5L12 3z" />
    <path d="M8 3l1 3 3 1-3 1-1 3-1-3-3-1 3-1 1-3zM21 16l-0.5-1.5L19 14l1.5-0.5L21 12l0.5 1.5L23 14l-1.5 0.5L21 16z" />
  </IconBase>
);

export const CreditCardIcon = (props) => (
  <IconBase {...props}>
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <line x1="2" y1="10" x2="22" y2="10" />
    <line x1="6" y1="15" x2="8" y2="15" />
    <line x1="10" y1="15" x2="14" y2="15" />
  </IconBase>
);

export const UsersIcon = (props) => (
  <IconBase {...props}>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </IconBase>
);

export const GlobeIcon = (props) => (
  <IconBase {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="M2 12h20" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </IconBase>
);

export const WonIcon = (props) => (
  <IconBase {...props}>
    <path d="M6 4l2 16M10 4l2 16M14 4l2 16M18 4l2 16" />
    <path d="M4 10h16M4 14h16" />
  </IconBase>
);

export const MessageCircleIcon = (props) => (
  <IconBase {...props}>
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    <path d="M8 9h8M8 13h4" />
  </IconBase>
);

// 🏠 Subscription 페이지 전용 아이콘들
export const UserIcon = (props) => (
  <IconBase {...props}>
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
  </IconBase>
);

export const CouponIcon = (props) => (
  <IconBase {...props}>
    <path d="M21 12V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v5m18 0v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5m18 0H3"/>
    <path d="M9 7v10M15 7v10"/>
  </IconBase>
);

export const ReferralIcon = (props) => (
  <IconBase {...props}>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="m22 21-3-3 3-3M16 8h.01M22 12h-4"/>
  </IconBase>
);

export const ClockIcon = (props) => (
  <IconBase {...props}>
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12 6 12 12 16 14"/>
  </IconBase>
);

export const CalendarIcon = (props) => (
  <IconBase {...props}>
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/>
    <line x1="8" y1="2" x2="8" y2="6"/>
    <line x1="3" y1="10" x2="21" y2="10"/>
  </IconBase>
);

export const LogOutIcon = (props) => (
  <IconBase {...props}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
    <polyline points="16 17 21 12 16 7"/>
    <line x1="21" y1="12" x2="9" y2="12"/>
  </IconBase>
);

export const TrashIcon = (props) => (
  <IconBase {...props}>
    <polyline points="3 6 5 6 21 6"/>
    <path d="m19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
  </IconBase>
);

export const MonitorIcon = (props) => (
  <IconBase {...props}>
    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
    <line x1="8" y1="21" x2="16" y2="21"/>
    <line x1="12" y1="17" x2="12" y2="21"/>
  </IconBase>
);

export const ShieldCheckIcon = (props) => (
  <IconBase {...props}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    <polyline points="9 12 10.5 13.5 15 9"/>
  </IconBase>
);

export const XIcon = (props) => (
  <IconBase {...props}>
    <line x1="18" y1="6" x2="6" y2="18"/>
    <line x1="6" y1="6" x2="18" y2="18"/>
  </IconBase>
);

// 🚀 로켓 아이콘 (생기부 생성, 시작 관련)
export const RocketIcon = (props) => (
  <IconBase {...props}>
    <path d="M4.5 16.5c-1.5 1.232-2 2.5-2 2.5s1.268-.515 2.5-2c.896-.896 2.025-2.025 2.5-2.5L9 16.5s-1.104-.896-2-1.5L4.5 16.5z"/>
    <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 9a22.35 22.35 0 0 1-4 2z"/>
    <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/>
    <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/>
  </IconBase>
);

// 🔔 벨 아이콘 (알림, 공지사항 관련)
export const BellIcon = (props) => (
  <IconBase {...props}>
    <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/>
    <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
  </IconBase>
);

// 기본 export
const ChatCategoryIcons = {
  DocumentIcon,
  FileIcon,
  HandshakeIcon,
  BrainIcon,
  SchoolIcon,
  ChartIcon,
  PresentationIcon,
  EventIcon,
  StarIcon,
  ImageIcon,
  DiamondIcon,
  CounselingCareIcon,  // 🆕 통합 상담·마음
  AdminDocsIcon,        // 🆕 행정 업무
  WorksheetPencilIcon,
  StudentRecordIcon,
  HwpUploadIcon,
  StampIcon,
  StudentCounselingIcon, // 레거시 (export 유지)
  FileUploadIcon,
  UpgradeIcon,
  CloseIcon,
  ModelIcon,
  TargetIcon,
  ClipboardIcon,
  SettingsIcon,
  RulerIcon,
  PaletteIcon,
  LightbulbIcon,
  CheckCircleIcon,
  WordCountIcon,
  RobotIcon,
  BrainMemoryIcon,
  SearchIcon,
  BookIcon,
  SparkleIcon,
  CreditCardIcon,
  UsersIcon,
  GlobeIcon,
  WonIcon,
  MessageCircleIcon,
  UserIcon,
  CouponIcon,
  ReferralIcon,
  ClockIcon,
  CalendarIcon,
  LogOutIcon,
  TrashIcon,
  MonitorIcon,
  ShieldCheckIcon,
  XIcon,
  RocketIcon,
  BellIcon,
  getCategoryIcon
};

export default ChatCategoryIcons;